// All 11 namespaces are registered here.

import { common as enCommon } from "./en/common";
import { login as enLogin } from "./en/login";
import { home as enHome } from "./en/home";
import { tournament as enTournament } from "./en/tournament";
import { liveScoreboard as enLiveScoreboard } from "./en/liveScoreboard";
import { profile as enProfile } from "./en/profile";
import { coachRating as enCoachRating } from "./en/coachRating";
import { studentCard as enStudentCard } from "./en/studentCard";
import { pickup as enPickup } from "./en/pickup";
import { match as enMatch } from "./en/match";
import { leaderboard as enLeaderboard } from "./en/leaderboard";
import { club as enClub, clubMatch as enClubMatch } from "./en/club";
import { league as enLeague, rating as enRating } from "./en/league";
import { roundup as enRoundup } from "./en/roundup";

import { common as zhCommon } from "./zh/common";
import { login as zhLogin } from "./zh/login";
import { home as zhHome } from "./zh/home";
import { tournament as zhTournament } from "./zh/tournament";
import { liveScoreboard as zhLiveScoreboard } from "./zh/liveScoreboard";
import { profile as zhProfile } from "./zh/profile";
import { coachRating as zhCoachRating } from "./zh/coachRating";
import { studentCard as zhStudentCard } from "./zh/studentCard";
import { pickup as zhPickup } from "./zh/pickup";
import { match as zhMatch } from "./zh/match";
import { leaderboard as zhLeaderboard } from "./zh/leaderboard";
import { club as zhClub, clubMatch as zhClubMatch } from "./zh/club";
import { league as zhLeague, rating as zhRating } from "./zh/league";
import { roundup as zhRoundup } from "./zh/roundup";

export const resources = {
  en: {
    common: enCommon,
    login: enLogin,
    home: enHome,
    tournament: enTournament,
    liveScoreboard: enLiveScoreboard,
    profile: enProfile,
    coachRating: enCoachRating,
    studentCard: enStudentCard,
    pickup: enPickup,
    match: enMatch,
    leaderboard: enLeaderboard,
    club: enClub,
    clubMatch: enClubMatch,
    league: enLeague,
    rating: enRating,
    roundup: enRoundup,
  },
  zh: {
    common: zhCommon,
    login: zhLogin,
    home: zhHome,
    tournament: zhTournament,
    liveScoreboard: zhLiveScoreboard,
    profile: zhProfile,
    coachRating: zhCoachRating,
    studentCard: zhStudentCard,
    pickup: zhPickup,
    match: zhMatch,
    leaderboard: zhLeaderboard,
    club: zhClub,
    clubMatch: zhClubMatch,
    league: zhLeague,
    rating: zhRating,
    roundup: zhRoundup,
  },
};
